import styled from 'styled-components';
import { archimedesTheme } from 'styles/theme';

const wrapperWidth = 268;
const tipWidth = 40;
const tipHeight = tipWidth / 2.5;
const borderRadius = archimedesTheme.borderRadius.main;

export const InfoWrapper = styled.div`
  position: relative;
  display: block;
  width: 1.8rem;
  height: 1.8rem;
`;

export const TipWrapper = styled.div`
  display: block;
  height: ${tipHeight}px;
  width: ${tipWidth}px;
  position: relative;
  fill: ${({ theme }) => theme.colors.primary.main};
  position: absolute;
  top: -${tipHeight}px;
  svg {
    width: 100%;
  }
`;

export const Content = styled.div`
  position: absolute;
  top: ${tipHeight + 14}px;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.functional.white};
  white-space: normal;
  font-size: 1.4rem;
  font-weight: 300;
  width: ${wrapperWidth}px;
  border-radius: ${borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow.blue};
  z-index: 2;
  p:last-child {
    margin-bottom: 0;
  }
  a {
    color: ${({ theme }) => theme.colors.functional.white};
    text-decoration: underline;
    &:hover {
      color: ${({ theme }) => theme.colors.functional.white};
    }
  }
`;

export const Wrapper = styled.div<{ position?: string; isShown?: string }>`
  position: relative;
  display: inline-block;
  margin: 0 0 0 3px;
  top: 4px;
  ${({ position }) => {
    switch (position) {
      case 'left':
        return `
            ${Content} {
                left: -${tipWidth - 10}px;
            }
            ${TipWrapper} {
                left: ${tipWidth / 2}px;
            }
          `;
      case 'right':
        return `
            ${Content} {
                right: -${tipWidth - 10}px;
            }
            ${TipWrapper} {
                right: ${tipWidth / 2}px;
            }
          `;
      case 'center':
        return `
        ${Content} {
            left: -${wrapperWidth / 2}px;
        }
        ${TipWrapper} {
            left: ${wrapperWidth / 2 - tipWidth / 2 + 10}px;
        }
      `;
    }
  }}
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    ${Content} {
      left: -${wrapperWidth / 2}px;
      right: auto;
    }
    ${TipWrapper} {
      left: ${wrapperWidth / 2 - tipWidth / 2 + 10}px;
      right: auto;
    }
  }
`;
